<template>
  <div class="dropbox-wrapper">
    <div class="dropbox"
         :style="{ width: width+'px', height: height+'px' }"
    >
      <input type="file"
             data-cy="image-input"
             name="image"
             ref="file"
             @change="onChange"
             accept="image/*"
             v-validate
             data-vv-rules="size:5120"
             v-if="!image"
      />
      <div class="hint" v-if="image">
        <img v-if="!showCropper"
             :src="image"
             class="preview"
             alt="image-preview"
        />
        <vue-cropper
          v-if="showCropper"
          ref="cropper"
          :img="image"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="true" :full="option.full"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :fixed-box="option.fixedBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :auto-crop-width="option.autoCropWidth"
          :auto-crop-height="option.autoCropHeight"
          :center-box="option.centerBox"
          @real-time="realTime"
          :high="option.high"
          :max-img-size="option.max"
        />
        <img @click="onRemove()"
             alt="delete-image-icon"
             class="delete-icon"
             src="@/assets/Uncheck.svg"
        />
      </div>
      <div class="hint" v-else>
        <img src="@/assets/DropImageIcon.svg"
             class="image-icon"
             alt="image-icon"
        />
        <div class="attachments-info">
          <div class="drag-image-title">
            {{ $t('shared.imageSelect.featuredImage', { context: context }) }}
          </div>
          <div v-html="$t('shared.imageSelect.dragAndDrop', {context: context})">
          </div>
        </div>
      </div>
    </div>
    <span data-cy="image-validation-message" class="validate-message" v-if="hasError"> {{ $t('shared.imageSelect.validationImageSize') }} </span>
  </div>
</template>

<script>
import Utils from '../../utils'
import { VueCropper } from 'vue-cropper'

export default {
  name: 'ImageSelect',
  components: { VueCropper },
  props: {
    width: {
      type: Number,
      required: false,
      default: 395
    },
    height: {
      type: Number,
      required: false,
      default: 221
    },
    idImage: {
      type: String,
      default: ''
    },
    context: {
      type: String,
      required: true
    },
    showCropper: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      image: '',
      option: {
        size: 1,
        full: true,
        outputType: 'png',
        canMove: true,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 750,
        autoCropHeight: 340,
        centerBox: true,
        high: true,
        max: 99999
      }
    }
  },
  async created() {
    this.image = this.source()
  },
  methods: {
    async realTime() {
      this.$refs.cropper.getCropData(data => {
        this.$emit('changeImage', {
          filename: this.image.name,
          data
        })
      })
    },
    async onChange(event) {
      const file = event.target.files[0]
      // max size : 5mo * 1024 = 5242880
      const base64Image = await Utils.convertFileToBase64(file, 5242880)
      this.image = base64Image
      this.$emit('changeImage', {
        filename: file.name,
        data: base64Image
      })
    },
    onRemove() {
      this.image = null
      this.$emit('removeImage', {})
    },
    source() {
      const image = this.$store.getters.image(this.idImage)
      return Utils.validBase64SrcString(image)
    }
  },
  computed: {
    hasError() {
      if (this.errors.has('image')) {
        this.onRemove()
        return true
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.dropbox-wrapper {
  width: 100%;
}

.dropbox {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  height: 197px;
  color: #2c3e50;
  max-width: calc(100vw - 60px);
  max-height: calc(100vw - 60px);

  @media (max-width: $header-change) {
    width: 100% !important;
    max-width: none;
  }

  input {
    box-sizing: border-box;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    position: absolute;
    border: solid 1px $cerise-color;
    z-index: 1;
  }

  .hint {
    border: 4px dashed #D8D8D8;
    border-radius: 3px;
    background: #F2F2F2;
    cursor: pointer;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;

    .attachments-info {
      flex-direction: column;
      font-size: 14px;

      .drag-image-title {
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
      }

      .blue {
        color: $primary-color
      }
    }

    .image-icon {
      width: 4em;
      max-width: 100px;
    }

    .preview {
      background: #FFFFFF;
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .delete-icon {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 3;
      background: white;
      border-radius: 20px;
    }
  }
}

.validate-message {
  color: $cerise-color;
  font-weight: bold;
  display: inline;
  font-size: 14px;
}

.dropbox:hover {
  background: #f2f2f2; /* when mouse over to the drop zone, change color */
}

.image-select {
  margin-left: 1.5rem;
  margin-top: 1.5rem;
  width: 395px;
}

</style>
